"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Attachement = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17.1222746,11.858062 C16.9277803,11.6635678 16.9277803,11.3482303 17.1222746,11.1537361 L18.1183419,10.1576687 C19.2991296,8.97688101 19.2991296,7.06244584 18.1183419,5.88165811 C16.9375542,4.70087038 15.023119,4.70087038 13.8423313,5.88165811 L5.88165811,13.8423313 C4.70087038,15.023119 4.70087038,16.9375542 5.88165811,18.1183419 C7.06244584,19.2991296 8.97688101,19.2991296 10.1576687,18.1183419 L14.3797928,13.8962178 C14.8733885,13.4026221 14.873918,12.6025088 14.3809759,12.1082602 C13.8893899,11.6153713 13.0913153,11.6143151 12.5984264,12.1059012 L9.84608252,14.8540574 C9.65139688,15.0484468 9.33602616,15.0483268 9.14148857,14.8537892 C8.94714235,14.659443 8.94714235,14.3443455 9.14148857,14.1499993 L9.14175658,14.1497315 L11.8929201,11.402754 C12.777425,10.5205843 14.206174,10.5224752 15.0862334,11.404867 C15.9672853,12.288254 15.966339,13.7183235 15.0841188,14.6005438 L10.8619947,18.8226678 C9.29221848,20.3924441 6.74710837,20.3924441 5.17733216,18.8226678 C3.60755595,17.2528916 3.60755595,14.7077815 5.17733216,13.1380053 L13.1380053,5.17733216 C14.7077815,3.60755595 17.2528916,3.60755595 18.8226678,5.17733216 C20.3924441,6.74710837 20.3924441,9.29221848 18.8226678,10.8619947 L17.8266005,11.858062 C17.6321063,12.0525562 17.3167688,12.0525562 17.1222746,11.858062 Z" })));
};
Attachement.displayName = 'Attachement';
exports.default = Attachement;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Attachement.js.map